import { constantRoutes, viewNames } from "@/router";
import MenuApi from "@/api/menu/menu";

/* Layout */
import Layout from "@/layout";

/**
 * 后台查询的菜单数据拼装成路由格式的数据
 * @param routes
 */
function generaMenu(routes, data, layer = 1, node = null) {
  data.forEach(item => {
    if (item.menuType && item.menuType !== "BUTTON") {
      if (node && !node.children) {
        node.children = routes;
        node.component = Layout;
        node.alwaysShow = true;
      }
      const menu = {
        path: !item.menuPath ? `${item.id}_key` : `${item.menuPath}`,
        name: item.menuCode,
        meta: { title: item.menuName, icon: item.menuIcon }
      };

      if (item.menuType !== "DIRECTORY" && item.menuPath) {
        const existMenu = viewNames.find(element => item.menuPath && item.menuPath.indexOf(element.path) !== -1);
        // 替换name
        if (existMenu) {
          menu.name = existMenu.name;
        }

        menu.meta.keepAlive = true;

        try {
          let com = null;
          if (item.menuPath.includes("/dynamic-page")) {
            com = require("@/views/standard/dynamic-page/dynamic-page-list");
          } else {
            com = require(`@/views/standard${item.menuPath}`);
          }
          // const com = require(`@/views/standard${item.menuPath}`);
          (com && com.default) && (menu.component = com.default);
          // menu.component = resolve => require([`@/views/standard${item.menuPath}`], resolve);
        } catch (error) {
          menu.component = resolve => require([`@/views/standard/404`], resolve);
        }
      }
      if (item.children && item.children.length) {
        menu.alwaysShow = false;
        let childLayer = layer;
        generaMenu([], item.children, ++childLayer, menu);
      } else if (layer === 1) {
        const childMenu = Object.assign({}, menu);
        menu.component = Layout;
        menu.redirect = menu.path;
        menu.children = [{
          ...childMenu,
          alwaysShow: true
        }];
      }
      routes.push(menu);
    }
  });
}

function deleteOtherMenu(arr, rootState) {
  for (let i = 0; i < arr.length; i++) {
    const menuItem = arr[i];
    if (menuItem.children && menuItem.children.length) {
      if (menuItem.children.length === 1 && (menuItem.children[0].menuPath === "/org-manage/org-manage-list" && rootState.user.infoData.enterpriseStructure !== "GROUP") || (menuItem.children.length === 1 && menuItem.children[0].menuPath === "/business/business-list" && !rootState.user.infoData.isSystemAdmin)) {
        arr.splice(i, 1);
        i--;
        continue;
      } else {
        deleteOtherMenu(menuItem.children, rootState);
      }
    }
    if (menuItem.menuPath === "/org-manage/org-manage-list" && rootState.user.infoData.enterpriseStructure !== "GROUP") {
      arr.splice(i, 1);
      i--;
    }
    if (menuItem.menuPath === "/business/business-list" && !rootState.user.infoData.isSystemAdmin) {
      arr.splice(i, 1);
      i--;
    }
  }
}
const state = {
  routes: constantRoutes,
  addRouters: [],
  routerInfo: {}
};

const mutations = {
  SET_ROUTERS: (state, routes) => {
    state.addRouters = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_ROUTER_INFO: (state, routerInfo) => {
    state.routerInfo = routerInfo;
  }
};

const actions = {
  generateRoutes({ commit, state, rootState }, roles) {
    return new Promise(resolve => {
      const loadMenuData = [];
      MenuApi.getMenuByRoleId()
        .then(response => {
          if (response.code !== 200) {
            this.$message({
              message: "菜单数据加载异常",
              type: 0
            });
          } else {
            const { data } = response;
            Object.assign(loadMenuData, data);
            deleteOtherMenu(loadMenuData, rootState);
            const route = [];
            generaMenu(route, loadMenuData);

            /*
               * const noMatch = { path: "*", redirect: "/404", hidden: true };
               * route.push(noMatch);
               */
            commit("SET_ROUTERS", route);
            return resolve(route);
          }
          // generaMenu(asyncRoutes, data)
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
